import { render, staticRenderFns } from "./integratorsProduct.vue?vue&type=template&id=49975a48&scoped=true"
import script from "./integratorsProduct.vue?vue&type=script&lang=js"
export * from "./integratorsProduct.vue?vue&type=script&lang=js"
import style0 from "./integratorsProduct.vue?vue&type=style&index=0&id=49975a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49975a48",
  null
  
)

export default component.exports